/**
 * matchFormat.js
 * Doubles support — see docs_zenanalytics/06-DOUBLES-SUPPORT-SPEC-2026-09-25.md.
 * One compact display helper used everywhere a plan's opponent is rendered,
 * so doubles data (a second opponent + a partner) is captured richly once
 * but compressed to a single string in every list/table/chart instead of
 * needing a second column or row everywhere.
 */

// Racket sports doubles is actually played in. Squash doubles exists but is
// rare enough, and organisationally absent here, that it's left out — easy
// to add later if it turns out to matter.
export const DOUBLES_SPORTS = ['tennis', 'padel', 'badminton', 'pickleball', 'table_tennis'];

export function supportsDoubles(sport) {
  return DOUBLES_SPORTS.includes(sport);
}

// "Petterson" (singles) / "Petterson & Karlsson" (doubles) / "Petterson & ?"
// (doubles, second opponent not filled in yet).
export function opponentLabel(plan) {
  if (!plan) return '';
  const first = plan.opponent_name || '';
  if (plan.match_format !== 'doubles') return first;
  const second = plan.opponent2_name || '?';
  if (!first) return second === '?' ? '' : `? & ${second}`;
  return `${first} & ${second}`;
}

// "with Karlsson" — doubles only, null otherwise. Deliberately not folded
// into opponentLabel: it's shown only in full detail views, never in
// compact table rows (see spec §3).
export function partnerLabel(plan) {
  if (!plan || plan.match_format !== 'doubles' || !plan.partner_name) return null;
  return `with ${plan.partner_name}`;
}

// Small marker for doubles matches in compact rows — singles renders nothing
// so singles (still the majority case) stays the unmarked default.
export function formatBadge(plan) {
  return plan?.match_format === 'doubles' ? '2v2' : null;
}
